import { FC } from "react";

import TableProjectInfo from "../../../components/table/projects/TableProjectInfo";

const ProjectInfo: FC = () => {
    return (
        <div >
            <TableProjectInfo />
        </div>
    );
};

export default ProjectInfo;
